import request from '@/utils/request';
export function fetchList(data) {
  return request({
    url: '/pmsservice/api/complaintReturn/list',
    method: 'post',
    data: data
  });
}
export function fetchCreate(data) {
  return request({
    url: '/pmsservice/api/complaintReturn/insert',
    method: 'post',
    data: data
  });
}
export function fetchDelete(data) {
  return request({
    url: '/pmsservice/api/complaintReturn/delete',
    method: 'post',
    data: data
  });
}
export function fetchUpdate(data) {
  return request({
    url: '/pmsservice/api/complaintReturn/update',
    method: 'post',
    data: data
  });
}
export function fetchDetail(data) {
  return request({
    url: '/pmsservice/api/complaintReturn/get',
    method: 'post',
    data: data
  });
}
export function returnStatistic(data) {
  return request({
    url: '/pmsservice/api/complaintReturn/returnStatistic',
    method: 'post',
    data: data
  });
}